import { View, Text } from "@react-pdf/renderer";

import { styles } from "../styles";

export function AdditionalInformation() {
  return (
    <View style={{ marginTop: 5, display: "flex", flexDirection: "column" }}>
      <Text
        style={{
          ...styles.bodyText,
          fontSize: 12,
          fontFamily: "Helvetica-Bold",
          marginBottom: 3,
        }}
      >
        Additional information:
      </Text>
      {/* CLE-2659: wording taken verbatim from CMS-R-131 (Exp. 03/31/2029). */}
      <Text style={{ ...styles.bodyText, fontSize: 12 }}>
        This notice gives our opinion, not an official Medicare decision. For
        other questions about this notice or Medicare billing, call{" "}
        <Text style={{ ...styles.bodyText, fontFamily: "Helvetica-Bold" }}>
          1-800-MEDICARE
        </Text>{" "}
        (1-800-633-4227). TTY users can call 1-877-486-2048. Signing below means
        you received and understand this notice. You can ask to get a copy.
      </Text>
    </View>
  );
}
